import { redirect, replace } from 'react-router'
import { publicAction } from '@/data/loaders';

export function loadScenarioOverview({ request, params }) {
  return new Promise(function(resolve, reject) {

    const { scenario_id } = params;

    publicAction("getScenarioOverview", { id: scenario_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Scenario not found or you don't have permission to view it", path: "/scenarios", status: 404 });
      }
    }).catch(reject);

  })
}

export function loadScenarioPreviews({ request, params }) {
  return new Promise(function(resolve, reject) {

    const { scenario_id } = params;

    publicAction("getScenarioPreviews", { id: scenario_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Scenario not found or you don't have permission to view it", path: "/scenarios", status: 404 });
      }
    }).catch(reject);

  })
}

export function loadScenario({ request, params }) {
  return new Promise(function(resolve, reject) {

    const { scenario_id, assessment_id, course_id } = params;

    if (scenario_id == "new") {
      return resolve({});
    }

    if (course_id && assessment_id) {
      publicAction("getAssessmentScenario", { id: assessment_id, course_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
        if (data.value) {
          resolve({ data });
        } else {
          reject({text: "Assessment not found", path: "/courses/"+course_id, status: 404 });
        }
      }).catch(reject);
    } else {
      publicAction("getScenario", { id: scenario_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
        if (data.value) {
          resolve({ data });
        } else {
          reject({text: "Scenario not found or you don't have permission to edit it", path: "/scenarios", status: 404 });
        }
      }).catch(reject);
    }

  })
}

export function loadScenarioForNewAssessment({ request, params }) {
  return new Promise(function(resolve, reject) {

    const { scenario_id } = params;

    publicAction("getScenario", { id: scenario_id, for_new_assessment: true }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Scenario not found or you don't have permission to view it", path: "/scenarios", status: 404 });
      }
    }).catch(reject);

  })
}

export function scenarioSubmit({ request, params }) {
  return new Promise(function(resolve, reject) {

    let searchParams = (new URLSearchParams((new URL(request.url)).search));
    let assessment_id_param = searchParams.get("assessment_id");
    let course_id_param = searchParams.get("course_id");
    let folder_id = searchParams.get("folder_id");

    const { scenario_id, assessment_id, course_id } = params;

    request.json().then(function({ update_assessment_only, ...request_data }) {

      if (update_assessment_only || (assessment_id && course_id)) {

        publicAction("updateAssessmentScenario", {
          id: assessment_id || assessment_id_param,
          course_id: course_id || course_id_param,
          ...request_data
        }).then(function({ data }) {
          if (data.share_prompt_files) {
            resolve({share_prompt_files: data.share_prompt_files, show_should_share_files_prompt: data.show_should_share_files_prompt, request_data, date: Date.now(), dont_revalidate: true});
          } else {
            resolve({success: true, date: Date.now()});
          }
        }).catch(() => {
          resolve({success: false, date: Date.now()});
        });

      } else {

        publicAction("createOrUpdateScenario", {
          id: scenario_id == "new" ? null : scenario_id,
          parent: folder_id || null,
          ...request_data,
          from_assessment_id: assessment_id_param || null
        }).then(function({ data }) {
          if (data.share_prompt_rubrics) {
            resolve({share_prompt_rubrics: data.share_prompt_rubrics, people_missing_access: data.people_missing_access, request_data, date: Date.now(), dont_revalidate: true});
          } else {
            if (scenario_id === "new") {
              resolve(replace("/scenarios/"+data.item_id));
            } else {
              resolve({success: true, date: Date.now()});
            }
          }
        }).catch(() => {
          resolve({success: false, date: Date.now()});
        });

      }

    })
  })
}

export function autofillScenario({ part, scenario_data }) {
  return publicAction("autofillScenario", { part, scenario_data });
}

export function generateRandomNames() {
  return publicAction("autofillScenarioName", {})
}

export function autofillScenarioAddItem({ part, scenario_data, item_name }) {
  return publicAction("autofillScenarioAddItem", { part, scenario_data, item_name });
}

export function renameScenario({ id, title }) {
  return publicAction("renameScenario", { id, title });
}